if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);
        } else {
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);
      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

/* This class isn't usable on its own
 * Extend it and add the _updateOn, htmlSelectors, jsSelectors, _template 
 */
class MiniCartPlugin {
  constructor(miniCartParent) {
    this._miniCartParent = miniCartParent;
  }

  update(cart) {
    // Create a set of the selectors to update
    const selectors = new Set();
    const updateSelector = selector => selectors.add(selector || -1); // Create a function to add the selectors that is passed to the updateOn function
    // Call the updateOn with (cart: Object, oldCart: object, update: (selector: string) => void); calling update() with no selectors will rerender the whole plugin
    this._updateOn(cart, this.cart, this.jsSelectors, (selector) => updateSelector(selector));
    // Refresh the updated elements
    this.refresh(cart, selectors);
    this.cart = cart;
  }

  refresh(cart, selectors) {
    const content = this.render(cart);
    for (const selector of selectors) {
      const contentEl = selector !== -1 && content.querySelector(selector);
      const currentEl = selector !== -1 && this._el.querySelector(selector);
      // If both doesn't exist do nothing
      if (!contentEl && !currentEl && selector !== -1) break;
      // if either elements doesn't exist or the the upate function was called with no selectors update the whole plugin
      if (!contentEl || !currentEl || selector === -1) {
        this._el.innerHTML = content.innerHTML;
        break;
      } else {
        currentEl.innerHTML = contentEl.innerHTML;
        for (const attr of contentEl.attributes) {
          currentEl.setAttribute(attr.name, attr.value);
        }
      }
    }

    if (cart.total_price < 10000) {
      document.getElementById('hc-cart-shipping-text').textContent = `You are $${(10000 - cart.total_price) / 100} away from free shipping!`;
      document.getElementById('hc-cart-shipping-bar-inner').style.width = `${(cart.total_price / 10000) * 100}%`;
    } else {
      document.getElementById('hc-cart-shipping-text').textContent = `You have unlocked free shipping!`;
      document.getElementById('hc-cart-shipping-bar-inner').style.width = '100%';
    }

    if (cart.item_count > 0) {
      const productRecommendationsSection = document.querySelector('.cart-recommendations');
      const url = `/recommendations/products?section_id=cart-recommendations&product_id=${cart.items[0].product_id}&limit=3&intent=related`;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.cart-recommendations');
    
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }

          const productBundleUpgradeSection = document.querySelector('.cart-bundle-upgrade-container');
          const url = '/?sections=cart-bundle-upgrade';
          fetch(url)
            .then(response => response.json())
            .then(json => {
              console.log('json:', json);
              const html = document.createElement('div');
              html.innerHTML = json['cart-bundle-upgrade'];
              const newSection = html.querySelector('.cart-bundle-upgrade-container');
              productBundleUpgradeSection.innerHTML = newSection.innerHTML;
            })
            .catch(e => {
              console.error(e);
            });
        })
        .catch(e => {
          console.error(e);
        });
    } else {
      const productRecommendationsSection = document.querySelector('.cart-recommendations');
      productRecommendationsSection.innerHTML = '';
      const productBundleUpgradeSection = document.querySelector('.cart-bundle-upgrade-container');
      productBundleUpgradeSection.innerHTML = '';
    }
    
    if (this.onRefresh) this.onRefresh();
  }

  init(cart) {
    this.cart = cart;
    this._el = this.render(cart);
    if (this.onInit) this.onInit();
    return this._el;
  }

  render(cart) {
    const globalCtx = {
      selectors: this.htmlSelectors,
      cart: cart,
      miniCartParent: this._miniCartParent,
      formatPriceOptions: this._miniCartParent.formatPriceOptions
    }
    const ctx = {
      ...globalCtx,
      ...(this.ctx(cart, globalCtx)),
    };
    
    var hc_samples = false;
    var hc_class = '';
    var hc_empty = '';
    
    $(cart.items).each(function(index, element) {
      if(element.handle.indexOf('sample') != -1){
        hc_samples = hc_samples + element.quantity;
      }
    });

    var hc_giftcard_only = true;
    $(cart.items).each(function(index, element) {
      if(element.handle.indexOf('gift-card') == -1){
        hc_giftcard_only = false;
      }
    });

    console.log('hc_giftcard_only:', hc_giftcard_only);
    
    if(hc_samples > 2){
      hc_class = 'hc_sample';
    }
    if(cart.item_count == 0 || hc_giftcard_only == true){
      hc_empty = 'hc-hidden';
    }else{
      hc_empty = '';
    }
    const htmlContent = `<section class="${hc_class} ${hc_empty} hc-mini-cart-plugin--${this.pluginName}" data-cart-plugin-content="${this.pluginName}">${this._template(ctx)}</section>`;
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");
    return doc.querySelector("[data-cart-plugin-content]");    
  }

  get element() {
    return this._el;
  }
}

class MiniCart {
  constructor(opts = { cartClass: 'hc-mini-cart-opened', bodyClass: 'hc-mini-cart-opened', template: null, id: null, formatOptions: null }) {
    const _defaults = { cartClass: 'hc-mini-cart-opened', bodyClass: 'hc-mini-cart-opened', template: null, id: null, formatOptions: null };
    if (!opts.id) {
      let id = '';
      for (let x = 0; x < 12; x++) id += '' + Math.floor(Math.random() * 10);
      this.id = id;
    }
    this._selectors0 = {
      count: 'data-cart-count',
      items: 'data-cart-items',
      item: 'data-cart-item',
      price: 'data-cart-total-price',
      quantityInput: 'data-cart-quantity',
      quantityChange: 'data-cart-quantity-change',
      close: `data-cart-close="${this.id}"`
    };
    this._selectors = {
      count: '[data-cart-count]',
      items: '[data-cart-items]',
      item: '[data-cart-item]',
      itemIdAttribute: 'data-cart-item',
      price: '[data-cart-total-price]',
      quantityInput: '[data-cart-quantity]',
      quantityChange: '[data-cart-quantity-change]',
      quantityChangeAttribute: 'data-cart-quantity-change',
      close: `[data-cart-close="${this.id}"]`
    };
    this.classes = {
      open: opts.cartClass || _defaults.cartClass,
      body: opts.bodyClass || _defaults.bodyClass
    };
    this.formatPriceOptions = opts.formatOptions || _defaults.formatOptions;
    if (!opts.template || !typeof opts.template == 'Function') {
      throw new TypeError("Please pass a template through the template property");
    } else {
      this.renderFn = opts.template;
    }

    // Events containers
    this._updates = [];
  }

  // Update cart function
  update() {
    if (!this.exists) {
      this.implement();
    }
    const cartPromise = fetch('/cart.js').then(res => res.json());
    return this._updateCartContent(cartPromise);
  }

  _updateCartContent(cartPromise) {
    return cartPromise
      .then(cart => {
        return ({
          content: this._render(cart),
          cart: cart
        });
      }
      )
      .then(({ content, cart }) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, "text/html");
        return {
          content: doc.querySelector('[data-cart-container]'),
          cart
        };
      })
      .then((res) => { this._fireUpdateEvent(res.cart); return res; })
      .then(({ content, cart }) => {
        Shopify.getCart(function(cart){
          this.refresh(content, cart);
          this.updatePlugins(cart)
        }.bind(this));
      })
  }

  _fireUpdateEvent(cart) {
    for (const cb of this._updates) {
      cb(cart);
    }
  }
  // Refresh cart content with a new content
  refresh(content) {
    if (this._el.querySelector(this._selectors.count)) this._el.querySelector(this._selectors.count).innerHTML = content.querySelector(this._selectors.count).innerHTML;
    if (this._el.querySelector(this._selectors.items)) this._el.querySelector(this._selectors.items).innerHTML = content.querySelector(this._selectors.items).innerHTML;
    if (this._el.querySelector(this._selectors.price)) this._el.querySelector(this._selectors.price).innerHTML = content.querySelector(this._selectors.price).innerHTML;
    return content;
  }

  // Open cart even if not implemented
  async open() {
    if (!this.exists) {
      await this.implement();
    }
    this._el.classList.add(this.classes.open);
    document.querySelector('body').classList.add(this.classes.body);

    const productRecommendationsSection = document.querySelector('.cart-recommendations');
    const firstProductRecommendationsItem = document.querySelector('.cart-recommendations-item');
    const firstCartItem = document.querySelector('.hc-cart-line-items');
    if (firstCartItem != null && firstProductRecommendationsItem == null) {
      const url = `/recommendations/products?section_id=cart-recommendations&product_id=${firstCartItem.getAttribute('data-product-id')}&limit=3&intent=related`;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.cart-recommendations');
    
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
    // hide samples if visitor is not from the US
    const res = await fetch('/browsing_context_suggestions.json');
    const json = await res.json();
    if(json.detected_values.country.handle !== 'US') {
      $('#shopify-section-hc-cart-upsell').hide();
    }
  }
  close() {
    this._el.classList.remove(this.classes.open);
    document.querySelector('body').classList.remove(this.classes.body);
  }
  updateQty(id, qty) {
    const cartPromise = fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: { [id]: qty } }),
    }).then(cart => cart.json());
    
    return this._updateCartContent(cartPromise);
  }
  updateMultipleItems(cartUpdateObject) {
    const cartPromise = fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: cartUpdateObject }),
    }).then(cart => cart.json());
    
    return this._updateCartContent(cartPromise);
  }
  _render(cart) {
    return this.renderFn(this, {
      cart,
      items: cart.items,
      count: cart.item_count,
      price: cart.total_price,
      selectors: this._selectors0,
      formatPriceOptions: this.formatPriceOptions
    });
  }
  async implement() {
    const cart = await fetch('/cart.js').then(res => res.json());
    const content = this._render(cart);

    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    document.querySelector('body').append(doc.querySelector('[data-cart-overlay]'));
    const el = this._el = doc.querySelector('[data-cart-container]');

    document.querySelector('body').append(el);

    this.implementPlugins(cart);

    document.querySelector('body').addEventListener('change', (e) => {
      if (e.target.matches(this._selectors.quantityInput)) {
        this.updateQty(e.target.closest(this._selectors.item).getAttribute(this._selectors.itemIdAttribute), e.target.value)
      }
    });

    document.querySelector('body').addEventListener('click', (e) => {
      if (e.target.matches(this._selectors.quantityInput)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      if (e.target.matches(this._selectors.quantityChange)) {
        const val = Number(e.target.getAttribute(this._selectors.quantityChangeAttribute));
        const inp = e.target.closest(this._selectors.item).querySelector(this._selectors.quantityInput);
        inp.value = val == 0 ? 0 : Number(e.target.closest(this._selectors.item).querySelector(this._selectors.quantityInput).value) + Number(val);
        this.updateQty(e.target.closest(this._selectors.item).getAttribute(this._selectors.itemIdAttribute), inp.value)
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      if (e.target.matches(this._selectors.close)) {
        this.close()
      }
    });

    document.querySelector('body').addEventListener('click', (e) => {
      if (e.target.classList.contains('js-bundle-update')) {
        e.preventDefault();
        e.stopPropagation();

        // grab variables
        let updates = {};

        const idToAdd = e.target.getAttribute('data-bundle-add');
        const idToRemove = e.target.getAttribute('data-bundle-remove');

        updates[idToAdd] = 1;
        updates[idToRemove] = 0;

        // make fetch call
        this.updateMultipleItems(updates);
        return false;
      }
    });

    this.exists = true;
  }
  // Plugins 
  implementPlugins(cart) {
    this._pluginInstances = [];
    const plugins = Array.from(this._el.querySelectorAll(`section[hc-plugin]`));
    for (const initiator of plugins) {
      const selector = initiator.getAttribute("hc-plugin");
      if (this._plugins.has(selector)) {
        const Plugin = this._plugins.get(selector);
        const params = JSON.parse(JSON.stringify(initiator.dataset));
        params.children = initiator.children;
        params.childrenHTML = initiator.innerHTML;
        const plugin = new Plugin(this, params);
        plugin.init(cart);
        initiator.after(plugin.element);
        initiator.remove();
        this._pluginInstances.push({
          plugin,
          params,
          selector,
        })
      }
    }
  }

  updatePlugins(cart) {
    for (const instance of this._pluginInstances) {
      instance.plugin.update(cart);
    }
  }

  registerPlugin(pluginClass, selector) {
    this._plugins = this._plugins || new Map();
    this._plugins.set(selector, pluginClass);
  }
  // Events 
  onUpdate(cb) {
    this._updates.push(cb);
  }

  addProduct(formOrId, qty) {
    let fetched;
    if (qty && (typeof formOrId === "string")) {
      const vals = {};
      vals.id = formOrId;
      vals.quantity = qty;
      fetched = fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(vals),
      })
      
    } else {
      const form = formOrId;
      // form.querySelectorAll("textarea, select, input").forEach(el => el.getAttribute('name') && el.value && (vals[el.getAttribute('name')] = el.value))
      const body = new FormData(form);
      
      fetched = fetch('/cart/add', {
        method: 'POST',
        body
      });
    }
    fetched
      .then(() => this.update())
      .then(() => this.open());
  }
}